import { render } from "./header.html?vue&type=template&id=59b7fe11&ts=true&external"
import script from "./header.ts?vue&type=script&lang=ts&external"
export * from "./header.ts?vue&type=script&lang=ts&external"

import "./header.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__